import * as qs from "query-string-for-all";
import * as React from "react";
import axios from "axios";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";
import Loading from "src/components/general/Loading";
import { baseUrl } from "src/constants/ApiSettings";
import { ICouncil } from "src/interfaces";
import { FormatNumber } from "src/components/utils/FormatNumber";

interface IProps {
  council: ICouncil;
  year: string;
  ordinal: number;
}

interface ITrace {
  residents: number;
  area: number;
  map: string;
}

interface IState {
  data: ITrace | null;
}

export default class SingleCouncil extends React.PureComponent<
  IProps,
  IState,
  ICouncilIdentityBadge
> {
  public state: IState = { data: null };

  public componentDidMount() {
    this.generateData(this.props.council, this.props.year);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateData(newProps.council, newProps.year);
    }
  }

  public generateData = (council: ICouncil, year: string) => {
    axios
      .all([
        axios.get(
          `${baseUrl}/area?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/totalArea?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/residentPopulation?${qs.stringify({
            council: council.id,
            year
          })}`
        )
      ])
      .then(
        axios.spread((resMap, resTotalArea, resPopulation) => {
          const map = resMap.data[0].path;
          const area = resTotalArea.data[0].value;
          const residents = resPopulation.data[0].value;

          const data: ITrace = {
            area,
            map,
            residents
          };

          this.setState({ data });
        })
      )
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  };

  public render() {
    const data = this.state.data;

    if (!data) {
      return (
        <div className="flex w-1/4 items-center justify-center">
          <Loading />
        </div>
      );
    }

    return (
      <div className="pr-4">
        {/* Council Badge */}
        <div className="flex flex-row items-center">
          <CouncilIdentityBadge
            badge={ this.props.ordinal }
            name={ this.props.council.name }
          />
        </div>
        {/* Map */}
        <div className="council-size">
          <div className="council-size__media">
            <img
              src={require(`../../../../assets/${data.map}`)}
            />
          </div>
        </div>
        {/* Km^2 */}
        <h2>
          { FormatNumber( data.area, 1 ) }
          <small>
            {" "}
            km<sup>2</sup>
          </small>
        </h2>
        {/* Res per Km^2 */}
        <h2>
          {/* Output the residents in decimal point format */
           Math.round( ( data.residents / data.area ) * 100 ) / 100
         }
          <small>
            {" "}
            residents per km<sup>2</sup>
          </small>
        </h2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilArea/SizeOf/SingleCouncil.tsx